export default "__VITE_ASSET__DhTdAkPm__"